<template>
	<az-container class="gestao-pedido mt-0">
		<v-tabs
			class="pd-0 v-tabs"
			grow
			:fixed-tabs="!$vuetify.breakpoint.smAndUp"
			:dark="false"
			:vertical="!$vuetify.breakpoint.smAndUp"
			:hide-slider="false"
		>
			<template v-for="aba in abas">
				<v-tab
					active-class="tab-ativa"
					:key="aba.titulo"
					@click="alterarVisibilidadeAba(aba)"
					class="tab-header"
					append
				>
					{{ aba.titulo }}
				</v-tab>
			</template>

			<v-divider class="mr-3 ml-5" vertical></v-divider>

			<az-toolbar class="interna az-toolbar">
				<template #actions>
					<botao-primario
						nome-botao="Novo Pedido"
						icone="mdi-plus-circle"
						v-az-auth="permissoes.pedidoUtilizacaoRascunhoCriar"
						v-if="!isHistoricoProrrogacao && !isAtaCancelada"
						@click="verificarOrgao"
					></botao-primario>
				</template>
				<template #simpleSearch>
					<az-search
						class="az-search"
						simple-search-placeholder="Busque pelo numero do pedido"
						@remove-filter="removerFiltros"
						@simple-search="carregarPedidos"
						:filter="filtro"
					></az-search>
				</template>
			</az-toolbar>
			<v-divider></v-divider>
		</v-tabs>
		<v-row v-if="isFiltroOrgaoVisible">
			<v-col cols="12" offset-sm="10" sm="2">
				<v-autocomplete
					clearable
					chips
					dense
					:items="orgaos"
					:filter="orgaoFilter"
					v-model="busca.filtro.idOrgao"
					item-value="idOrgao"
					label="Filtro por órgão"
					@click:clear="removerFiltros('idOrgao')"
					@input="carregarPedidos(null)"
					hide-details
					outlined
				>
					<template #item="{ item }">
						<v-tooltip color="black" top>
							<template #activator="{ on, attrs }">
								<div
									v-on="on"
									v-bind="attrs"
									v-html="
										$options.filters.HighlightBuscaFilter(
											formatarCodigoSigla(item),
											textoBuscaOrgao,
										)
									"
								></div>
							</template>
							<span>{{ item.siglaDescricao }}</span>
						</v-tooltip>
					</template>
					<template #selection="{ item }">
						<v-tooltip color="black" top>
							<template #activator="{ on, attrs }">
								<div v-on="on" v-bind="attrs">
									{{ formatarCodigoSigla(item) }}
								</div>
							</template>
							<span>{{ item.siglaDescricao }}</span>
						</v-tooltip>
					</template>
				</v-autocomplete>
			</v-col>
		</v-row>
		<listagem-collapses-pedidos
			:items="pedidosDatasorce"
			:paginacao="busca.paginacao"
			:total-itens="totalItens"
			:total-paginas="totalPaginas"
			:aba="abaSelecionada"
			:existe-pedido="existePedido"
			@botao-evento="verificarOrgao"
			@paginar="setPaginacaoListagem"
			@recarregar-processos="carregarPedidos"
		></listagem-collapses-pedidos>
		<escoher-orgao-dominio
			:exibir="exibirModalOrgaos"
			titulo-modal="Criação de pedido"
			subtitulo="Para qual órgão deseja criar o pedido?"
			:orgaos="orgaos"
			@buscar-orgaos="carregarOrgaos"
			@fechar="fecharModalOrgaos"
			@orgao-selecionado="criarNovoPedido"
		></escoher-orgao-dominio>
	</az-container>
</template>
<script>
import { actionTypes, mutationTypes, routesNames, situacoes, tipoAcesso } from '@/core/constants'
import ListagemCollapsesPedidos from '@/views/pages/ata/acessar/gestao-de-pedido/listagem-collapses-pedidos/ListagemCollapsesPedidos.vue'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import { mapState } from 'vuex'
import EscoherOrgaoDominio from '@/views/pages/comum/escolher-orgao/EscolherOrgaoDominio.vue'
import HighlightBuscaFilter from '@/views/filters/highlight-busca-filter'
import validacaoAta from '@/views/mixins/validacaoAta'
import permissoesMixin from '@/views/mixins/permissoes-mixin'

export default {
	name: 'gestao-de-pedido-view',
	components: { EscoherOrgaoDominio, BotaoPrimario, ListagemCollapsesPedidos },
	filters: { HighlightBuscaFilter },
	mixins: [validacaoAta, permissoesMixin],
	data() {
		return {
			isComponenteAtivo: true,
			pedidosDatasorce: [],
			totalPaginas: 0,
			totalItens: 0,
			orgaos: [],
			exibirModalOrgaos: false,
			textoBuscaOrgao: '',
			busca: this.getFiltroBusca(null, situacoes.ATA.GESTAO_PEDIDO.EM_ANDAMENTO),
			abas: this.getAbas(),
			abaSelecionada: this.getAbas()[0],
			existePedido: false,
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.ata.gestaoPedido.filtro,
			filtroOrgao: (state) => state.ata.gestaoPedido.idOrgao,
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
		isHistoricoProrrogacao() {
			return this.informacoesAta && this.ehHistoricoProrrogacao(this.informacoesAta)
		},
		isFiltroOrgaoVisible() {
			return this.orgaos.length > 1 && this.existePedido
		},
		isAtaCancelada() {
			return this.estaCancelada(this.informacoesAta.situacao)
		},
	},
	async mounted() {
		await Promise.all([this.carregarOrgaos(), this.carregarPedidos(), this.verificarSeExistePedido()])
	},
	beforeDestroy() {
		this.isComponenteAtivo = false
	},
	methods: {
		orgaoFilter(item, queryText) {
			const textoSigla = item.siglaOrgao.toLowerCase()
			const textoCodigo = item.codigoOrgao?.toLowerCase() || ''
			const searchText = queryText.toLowerCase()
			this.textoBuscaOrgao = queryText
			return textoSigla.indexOf(searchText) > -1 || textoCodigo.indexOf(searchText) > -1
		},
		async carregarOrgaos() {
			if (!this.isComponenteAtivo) return
			const { itens } = await this.$store.dispatch(
				actionTypes.PEDIDO.BUSCAR_ORGAOS_DO_USUARIO,
				this.$route.params.id,
			)
			this.orgaos = itens
		},
		async carregarPedidos(busca) {
			if (!this.isComponenteAtivo) return
			if (busca) this.filtro.numeroPedido.value = busca
			this.setIdOrgaoFiltro(this.busca.filtro.idOrgao)
			let { itens, totalElements, totalPages } = await this.buscarPedidosPorProcesso(this.busca)
			this.pedidosDatasorce = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
		},
		async buscarPedidosPorProcesso(filtro) {
			return await this.$store.dispatch(actionTypes.ATA.GESTAO_PEDIDO.BUSCAR_LISTAGEM_PEDIDOS_COLLAPSE, filtro)
		},
		async criarNovoPedido(orgaoSelecionado) {
			await this.$store.dispatch(actionTypes.COMUM.ATUALIZAR_SESSAO, orgaoSelecionado)

			this.fecharModalOrgaos()
			await this.novoPedido()
		},
		async verificarOrgao() {
			if (this.$store.state.ata.gestaoPedido.idOrgao > 0) {
				await this.criarNovoPedido(this.$store.state.ata.gestaoPedido.idOrgao)
				return
			} else {
				await this.carregarOrgaos()
				if (this.orgaos.length === 1) {
					await this.criarNovoPedido(this.orgaos[0].idOrgao)
					return
				}
			}
			this.exibirModalOrgaos = true
		},
		fecharModalOrgaos() {
			this.exibirModalOrgaos = false
		},
		async redirecionarParaCriarNovoPedido(idPedido) {
			await this.$router.push({
				name: routesNames.PEDIDO.NOVO_VIEW,
				params: {
					id: idPedido,
					idAta: this.$route.params.idAta,
					tipoAcesso: tipoAcesso.SELECAO_ITEM_PEDIDO.NOVO,
				},
			})
		},
		async novoPedido() {
			const data = await this.$store.dispatch(actionTypes.ATA.GESTAO_PEDIDO.NOVO_PEDIDO, {
				idAta: this.$route.params.id,
				idOrgao: this.$store.state.loki.user.domainId,
			})

			await this.redirecionarParaCriarNovoPedido(data.idPedido)
		},
		async removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}
			if (propriedade === 'idOrgao') {
				this.busca.filtro.idOrgao = null
				this.setIdOrgaoFiltro(null)
				this.textoBuscaOrgao = ''
			}
			await this.carregarPedidos(this.filtro.numeroPedido.value)
		},
		async verificarSeExistePedido() {
			if (!this.isComponenteAtivo) return
			let { totalElements } = await this.buscarPedidosPorProcesso(
				this.getFiltroBusca(null, situacoes.ATA.GESTAO_PEDIDO.EM_ANDAMENTO),
			)

			this.existePedido = totalElements + this.totalItens > 0
		},
		setIdOrgaoFiltro(value) {
			this.$store.commit(mutationTypes.PEDIDO.SET_ID_ORGAO_FILTRO_COLLAPSE, value)
		},
		setPaginacaoListagem(paginacao) {
			this.busca.paginacao = paginacao
			this.carregarPedidos(this.filtro.numeroPedido.value)
		},
		alterarVisibilidadeAba(aba) {
			this.inativarAbas()
			aba.isVisivel = true
			this.abaSelecionada = aba
			this.setSituacaoFiltro()
			this.carregarPedidos()
		},
		inativarAbas() {
			for (let i = 0; i < this.abas.length; i++) {
				this.abas[i].isVisivel = false
			}
		},
		setSituacaoFiltro() {
			this.busca.filtro.situacoes = this.abaSelecionada.situacoes
		},
		formatarCodigoSigla(item) {
			return item.codigoOrgao ? item.codigoOrgao + ' - ' + item.siglaOrgao : item.siglaOrgao
		},
		getFiltroBusca(idOrgao, situacoes) {
			return {
				filtro: {
					paginacao: paginacaoListagem(['id']),
					idAta: this.$route.params.id,
					idOrgao: idOrgao,
					situacoes: situacoes,
				},
				paginacao: paginacaoListagem(['id']),
			}
		},
		getAbas() {
			return [
				{
					id: 'EM_ELABORACAO',
					titulo: 'Em Andamento',
					isVisivel: true,
					textoListagemVazia: {
						mensagem: 'Você não possui <strong>pedido</strong> em andamento',
					},
					situacoes: situacoes.ATA.GESTAO_PEDIDO.EM_ANDAMENTO,
				},
				{
					id: 'CONCLUIDO',
					titulo: 'Concluídos',
					isVisivel: false,
					textoListagemVazia: {
						mensagem: 'Você não possui <strong>pedido</strong> concluído',
					},
					situacoes: situacoes.ATA.GESTAO_PEDIDO.CONCLUIDO,
				},
			]
		},
	},
}
</script>
<style lang="stylus">
.gestao-pedido
	min-height 7vh
	max-height max-content

	.v-tabs
		box-sizing: content-box !important
		margin-bottom 15px
		margin-top 15px

	.az-toolbar
		height auto !important

	.az-search
		box-sizing border-box !important

	.v-slide-group__wrapper
		height 43px

	.interna
		background-color white !important
		border none !important

	.v-label, .v-input__slot
		font-size 14px !important

	//todo corrigir

	.arp-botoes-assinatura
		display flex
		align-items center
		width 100%
		justify-content space-around
		margin-bottom 20px

		.v-btn
			min-width 7.8125rem !important

		.mensagem-modal
			display grid !important

	.texto-corpo
		color #726f6f
		font-size 15px
		font-weight 400
		text-align center
		font-style normal
		line-height 25px

.v-autocomplete__content.v-menu__content .v-select-list
	font-size 14px !important

//todo corrigir
</style>
